
// This is an auto generated file - do not edit!
// Swagger path: /api/Country/nonpaged

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    Country
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class CountryNonpagedApiService extends BaseApiService {
    
    get(options = {}): Observable<Country[]> {
        return this._get<Country[]>(
            `/Country/nonpaged`,
            options
        );
    }
}
